var React = require('react');

function MinusCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 1c3.859 0 7 3.141 7 7 0 3.86-3.141 7-7 7s-7-3.14-7-7c0-3.859 3.141-7 7-7zm4 8a1 1 0 1 0 0-2H4a1 1 0 1 0 0 2h8z"}));
}

MinusCircle.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = MinusCircle;

MinusCircle.default = MinusCircle;
